import type { AppMode } from "@/shared/constants/flags";

export function getAppModeFromEnv(): AppMode {
  const raw = (process.env as Record<string, unknown> | undefined)?.VUE_APP_MODE;
  const normalized = String(raw ?? "").trim().toLowerCase();

  if (normalized === "customer" || normalized === "vendor" || normalized === "default" || normalized === "customer_hoa") {
    return normalized;
  }
  return "default";
}

export function isVendorMode(): boolean {
  return getAppModeFromEnv() === "vendor";
}

